<section class="accessory-picker" aria-live="polite">
  <div class="accessory-heading">
    <span class="heading-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1"></path>
        <circle cx="12" cy="12" r="4"></circle>
      </svg>
    </span>
    <span class="heading-copy">
      <strong>בחרו את האבזור הקיים ברכב</strong>
      <small>ניתן לבחור מספר אפשרויות</small>
    </span>
    @if (selectedCount > 0) {
      <button type="button" class="clear-selection" (click)="clearSelection()">ניקוי הבחירה</button>
      <span class="selection-count">נבחרו {{ selectedCount }}</span>
    } @else {
      <span class="selection-count is-empty">לא נבחר</span>
    }
  </div>

  @if (isLoading) {
    <div class="accessory-grid" aria-label="טוענים אבזור">
      @for (placeholder of [1, 2, 3, 4, 5, 6]; track placeholder) {
        <div class="accessory-skeleton"><span></span><span></span></div>
      }
    </div>
  } @else if (loadError) {
    <div class="accessory-status error-status" role="alert">
      <mat-icon aria-hidden="true">error_outline</mat-icon>
      <span>לא הצלחנו לטעון את רשימת האבזור.</span>
      <button type="button" (click)="retry()">נסו שוב</button>
    </div>
  } @else if (list.length === 0) {
    <div class="accessory-status">
      <mat-icon aria-hidden="true">inventory_2</mat-icon>
      <span>לא נמצאו אפשרויות אבזור לקטגוריה הזאת.</span>
    </div>
  } @else {
    <div class="accessory-grid" role="group" aria-label="אפשרויות אבזור">
      @for (accessory of list; track accessory.id) {
        <button
          type="button"
          class="accessory-option"
          [class.is-selected]="isSelected(accessory)"
          [attr.aria-pressed]="isSelected(accessory)"
          (click)="toggleItem(accessory)">
          <span class="accessory-icon" aria-hidden="true">
            <mat-icon>{{ getIconName(accessory) }}</mat-icon>
          </span>
          <span class="accessory-label">{{ accessory.ArmatureDesc }}</span>
          <span class="selection-control" aria-hidden="true">
            <svg viewBox="0 0 20 20"><path d="M4.5 10.2l3.2 3.2 7.8-7.8"></path></svg>
          </span>
        </button>
      }
    </div>
  }
</section>
